import React, { Component } from 'react'
import Breadcumb from '../../../components/Breadcumb/Breadcumb'
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Alert from '@material-ui/lab/Alert';
import { Button, TextField, InputLabel, MenuItem } from '@material-ui/core';
const BreadcrumbData = [
    {
        id: 1,
        page_title: "Dashboard",
        page_path: "/",
        icon: "tachometer",
    },
    {
        id: 2,
        page_title: "Update Profile",
        page_path: "/app/profile",
        icon: "user",
    }
]
export default class EditProfile extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            fname: '',
            lname: '',
            gender: '',
            dob: '',
            address: '',
            city: '',
            state: '',
            country: '',
            formValid: false,
            fnameValid: true,
            lnameValid: true,
            genderValid: true,
            dobValid: true,
            addressValid: true,
            cityValid: true,
            stateValid: true,
            countryValid: true,
            formErrors: { fname: '', lname: '', gender: '', dob: '', address: '', city: '', state: '', country: '' },
        }
    }
    componentDidMount() {
        const user = this.props.data;
        this.setState({
            fname: user.fname,
            lname: user.lname,
            gender: user.gender,
            dob: user.dob,
            address: user.address,
            city: user.city,
            state: user.state,
            country: user.country,
            isLoading: false
        })

    }
    handleUserInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value },
            () => { this.validateField(name, value) });
    }

    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let { fnameValid, lnameValid, genderValid, dobValid, addressValid, cityValid, stateValid, countryValid } = this.state;

        switch (fieldName) {
            case 'fname':
                fnameValid = value.length !== 0;
                fieldValidationErrors.fname = fnameValid ? '' : ' Please enter your first name.';
                break;

            case 'lname':
                lnameValid = value.length !== 0;
                fieldValidationErrors.lname = lnameValid ? '' : ' Please enter your last name.';
                break;
            case 'gender':
                genderValid = value.length !== 0;
                fieldValidationErrors.gender = genderValid ? '' : ' Please select your gender.';
                break;
            case 'dob':
                dobValid = value.length !== 0;
                fieldValidationErrors.dob = dobValid ? '' : ' Please select your date of birth.';
                break;
            case 'address':
                addressValid = value.length !== 0;
                fieldValidationErrors.address = addressValid ? '' : 'Please enter your address.';
                break;
            case 'city':
                cityValid = value.length !== 0;
                fieldValidationErrors.city = cityValid ? '' : 'Please enter your city.';
                break;
            case 'state':
                stateValid = value.length !== 0;
                fieldValidationErrors.state = stateValid ? '' : 'Please enter your state.';
                break;
            case 'country':
                countryValid = value.length !== 0;
                fieldValidationErrors.country = countryValid ? '' : ' Please enter your country.';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            fnameValid: fnameValid,
            lnameValid: lnameValid,
            genderValid: genderValid,
            dobValid: dobValid,
            addressValid: addressValid,
            cityValid: cityValid,
            stateValid: stateValid,
            countryValid: countryValid,
        }, this.validateForm);
    }

    validateForm() {
        let { fnameValid, lnameValid, genderValid, dobValid, addressValid, cityValid, stateValid, countryValid } = this.state;
        this.setState({ formValid: fnameValid && lnameValid && genderValid && dobValid && addressValid && cityValid && stateValid && countryValid });
    }
    handleSubmit = async (e) => {
        e.preventDefault();
        const { fname, lname, gender, dob, address, city, state, country } = this.state;

        const data = {
            fname: fname,
            lname: lname,
            gender: gender,
            dob: dob,
            address: address,
            city: city,
            state: state,
            country: country,
        }

      this.props.onEditSubmit(data);
       
    }

    render() {

        const { isLoading, fname, lname, gender, dob, address, city, state, country, formErrors } = this.state;
        return (
            <>
                <Breadcumb items={BreadcrumbData} />
                <div className="page-wrapper mt20">
                    <Container >
                        <Card className="card mt20">
                            <Grid container>
                                <Grid item lg={9} sm={9}>
                                    <div className='formErrors-container' >

                                        {Object.keys(formErrors).map((fieldName, i) => {
                                            if (formErrors[fieldName].length > 0) {
                                                return (
                                                    <Alert severity="error" key={i}>{formErrors[fieldName]}</Alert>
                                                )
                                            } else {
                                                return '';
                                            }
                                        })}
                                    </div>
                                </Grid>
                            </Grid>
                            <form className="form" onSubmit={this.handleSubmit} noValidate>
                                <CardContent>
                                    <Typography variant="h5" gutterBottom>
                                        Edit Profile
                                    </Typography>
                                    {
                                        isLoading ? "Data loading.. " : <Grid container>
                                            <Grid item lg={9} sm={9}>

                                                <Grid container spacing={3}>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="First Name"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="fname"
                                                            value={fname}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="Last Name"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="lname"
                                                            value={lname}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            id="date"
                                                            label="Birthday"
                                                            variant="filled"
                                                            type="date"
                                                            defaultValue={dob}
                                                            className={`textField, flw100`}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                            name="dob"
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} sm={6}>

                                                        <FormControl className={`formControl, flw100`}>
                                                            <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                                                            <Select
                                                                labelId="demo-simple-select-label"
                                                                id="demo-simple-select"
                                                                name="gender"
                                                                variant="filled"
                                                                value={gender}
                                                                onChange={this.handleUserInput}
                                                                fullWidth={true}
                                                            >
                                                                <MenuItem value="male">Male</MenuItem>
                                                                <MenuItem value="female">Female</MenuItem>

                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={3}>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="Address"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="address"
                                                            value={address}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="City"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="city"
                                                            value={city}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid container spacing={3}>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="State"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="state"
                                                            value={state}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                    <Grid item lg={6} sm={6}>
                                                        <TextField
                                                            label="Country"
                                                            variant="filled"
                                                            fullWidth={true}
                                                            size="small"
                                                            name="country"
                                                            value={country}
                                                            onChange={this.handleUserInput}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    }
                                </CardContent>
                                <CardActions>
                                    <Button variant="contained" color="secondary" onClick={this.props.goBack}>Go Back</Button>
                                    <Button disabled={!this.state.formValid} variant="contained" color="primary" type="submit">Save</Button>
                                </CardActions>
                            </form>
                        </Card>
                    </Container>
                </div>
            </>
        )
    }
}
